// extracted by mini-css-extract-plugin
export default {"wrapper":"ResolvedAlertList_wrapper__HM1mT"};